import type { paydOrder } from '../../interfaces';

const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

export const formatCurrency = (value: number) => currencyFormatter.format(value);

export const formatDate = (value?: string) => {
  if (!value) {
    return '—';
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return value;
  }

  return date.toLocaleString();
};

export const formatAddress = (order: paydOrder) => {
  const snapshot = order.shippingAddress;
  const address = snapshot || order.user?.shippingAddresses?.[0];
  if (!address) {
    return 'No shipping address provided';
  }

  const lines = [];
  const name = snapshot?.name || [address.firstName, address.lastName].filter(Boolean).join(' ');

  if (name) {
    lines.push(name);
  }
  if (address.addressLine1) {
    lines.push(address.addressLine1);
  }
  if (address.addressLine2) {
    lines.push(address.addressLine2);
  }

  const cityLine = [address.city, address.province, address.postcode]
    .filter(Boolean)
    .join(', ');

  if (cityLine) {
    lines.push(cityLine);
  }
  if (address.country) {
    lines.push(address.country);
  }
  if (address.telephone) {
    const phoneSuffix = address.phoneCode ? ` (${address.phoneCode})` : '';
    lines.push(`Tel: ${address.telephone}${phoneSuffix}`);
  }

  return lines.join('\n');
};

export const getShortOrderId = (orderId: string) => {
  if (!orderId) {
    return '—';
  }
  if (orderId.length <= 12) {
    return orderId;
  }

  return `${orderId.slice(0, 6)}...${orderId.slice(-4)}`;
};
